import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export type AuthService = {
  currentUser$: Observable<AuthServiceUser>;
  logoutUrl: string;
};

export type AuthServiceUser = {
  id: string;
  name: string;
  employeeNumber: string | null;
  isImpersonating?: boolean;
  groups?: string[] | null;
};

export const AUTH_SERVICE = new InjectionToken<AuthService>('Auth service');
